/*!

=========================================================
* Vue Argon Dashboard PRO - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue';
import App from './App.vue';
import Amplify from 'aws-amplify';
import moment from 'moment';
import { Auth, Logger } from "aws-amplify";
import '@aws-amplify/ui-vue';
import { Hub } from 'aws-amplify';
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vue2Filters from 'vue2-filters'
import router from './routes/router'; 

// @ts-ignore
import aws_exports from './aws-exports';
  // @ts-ignore
import DashboardPlugin from "@/plugins/dashboard-plugin";

// load vue-boostrap
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

// plugins setup
Vue.config.productionTip = false
Vue.use(Vue2Filters);
Vue.use(DashboardPlugin);

//Axios setup
//axios.defaults.baseURL = "https://localhost:44305/api";
axios.defaults.baseURL = `${process.env.VUE_APP_API_BASE}/api`;
axios.interceptors.request.use(async config => {
  const jwtToken = await Amplify.Auth.currentSession().then((data:any) => {
      Vue.prototype.$jwtToken = data.idToken.jwtToken;
      axios.defaults.headers.common['Authorization'] = `Bearer ${Vue.prototype.$jwtToken}`;

      return data.idToken.jwtToken;
  });
  config.headers.common['Authorization'] = `Bearer ${jwtToken}`;
  return config;
});
Vue.use(VueAxios, axios);

// Amplify setup
Amplify.configure(aws_exports);
  // @ts-ignore
Vue.use(Auth, Logger);
  // @ts-ignore
Vue.use(Amplify);

Hub.listen('auth', (data) => {
  console.log(JSON.stringify(data));
  if (data.payload.event == "signOut") {
    router.push("/login");
  }
  if (data.payload.event == "signIn") {
    Vue.prototype.$jwtToken = data.payload.data.signInUserSession.idToken.jwtToken;
    Vue.prototype.$userName = data.payload.data.attributes.name;
    if (router.currentRoute.query.redirect) 
      router.push(router.currentRoute.query.redirect as string);
    else router.push("/dashboard");
  }
});

// Injecting custom global resources
declare module 'vue/types/vue' {
  interface Vue {
    $Amplify:any,
    moment:any
  }
}

Vue.prototype.$Amplify = Amplify;
Vue.prototype.moment = moment;
Vue.prototype.$jwtToken = "";
Vue.prototype.$providerData = {
  practices: [],
  selectedPractice: "",
};


// Custom filters, this should be better to be declared in a separate folder if we use more of this custom filters
Vue.filter("formatDate",
(value: Date, format: string, setLocal = true) => {
    if (value && format) {
        let momentDate = moment.utc(value);
        momentDate = setLocal ? momentDate.local() : momentDate;
        const res = momentDate.format(format);
        return res;
    } else return "";
}
);

// Vue Init
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  created() {
    Amplify.Auth.currentSession().then((data:any) => {
      console.log(data);
      Vue.prototype.$jwtToken = data.idToken.jwtToken;
      this.axios.get(`Provider/Practices`, {
        headers:{'Authorization':'Bearer ' + data.idToken.jwtToken}
      })
      .then(data => Vue.prototype.$providerData.practices = data.data);
    });
  }
});